import React from "react";

import { Grid, Card, Theme } from "@mui/material";
import { withStyles } from "tss-react/mui";

import { Recipe } from "@/gql/graphql";

import RecipeListItem from "./RecipeListItem";
import RecipeLoading from "./RecipeLoading";
import RecipesEmptyView from "./RecipesEmptyView";

const Root = withStyles(Card, (theme: Theme) => ({
  root: {
    flex: 1,
    overflowY: "auto",
    padding: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
}));

type Props = {
  recipeIds: Recipe["id"][];
  onDeleteRecipe: (id: Recipe["id"]) => Promise<void>;
  onDuplicateRecipe: (id: Recipe["id"]) => Promise<void>;
  isLoading: boolean;
};

const RecipesList: React.FC<Props> = ({
  recipeIds,
  isLoading,
  onDeleteRecipe,
  onDuplicateRecipe,
}) => {
  if (isLoading)
    return (
      <Root>
        <RecipeLoading />
      </Root>
    );

  return (
    <Root>
      {recipeIds.length !== 0 ? (
        <Grid container spacing={3} direction="column">
          {recipeIds.map((id, index) => (
            <Grid item xs={12} key={index}>
              <RecipeListItem
                id={id}
                onDeleteRecipe={onDeleteRecipe}
                onDuplicateRecipe={onDuplicateRecipe}
              />
            </Grid>
          ))}
        </Grid>
      ) : (
        <RecipesEmptyView />
      )}
    </Root>
  );
};

export default RecipesList;
